module.exports = __webpack_public_path__ + "static/media/116.582458f3.svg";